/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */

export var Scope = /*#__PURE__*/function (Scope) {
  Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
  Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
  Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
  Scope["ConfluenceSpace"] = "confluence.space";
  Scope["UserConfluence"] = "urs.user-confluence";
  return Scope;
}({});
export var ConfluencePageBlogAttachmentScope = 'confluence.page,blogpost,attachment';
export var ConfluencePageBlogScope = 'confluence.page,blogpost';
export var ConfluenceExpPageBlogAttachment = 'confluence_experiments.page,blogpost,attachment';
export var ConfluenceSpaceScope = 'confluence.space';
export var ConfluenceUserScope = 'urs.user-confluence';
/*****************/
/** Result Type **/
/*****************/
export var GenericContainerResult = 'generic-container-result';
export var PersonResult = 'person-result';
export var ConfluenceObjectResult = 'confluence-object-result';
/********************/
/** Analytics Type **/
/********************/
export var RecentConfluence = 'recent-confluence';
export var ResultConfluence = 'result-confluence';
export var RecentPerson = 'recent-person';
export var ResultPerson = 'result-person';
export var AdvancedSearchConfluence = 'advanced-search-confluence';
export var AdvancedSearchPeople = 'advanced-search-people';
/******************/
/** Content Type **/
/******************/
export var ConfluencePage = 'confluence-page';
export var ConfluenceBlogpost = 'confluence-blogpost';
export var ConfluenceAttachment = 'confluence-attachment';
export var ConfluenceSpace = 'confluence-space';
export var Person = 'person';

/*****************************************/
/** Scope.UserConfluence **/
/*****************************************/

/****************************************************************/
/** Scope.ConfluencePageBlogAttachment & Scope.ConfluenceSpace **/
/****************************************************************/